import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';
import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';

import Expertise from '../list/expertise/index';
import Estimate from '../list/estimate/index';

const API_PATH = 'event-poll-question-estimates';

export const ExpertiseManager = {
  estimates: objectsRHandler(API_PATH, Estimate),
  expertises: {
    index({ args, params } = DEFAULT_PARAMS) {
      const [estimateId] = args;
      return rHandler(
        apiService.get(`${API_PATH}/${estimateId}/expertises`, params),
        (response) => ({
          response,
          items: response.data.data.map((i) => new Expertise(i, `${API_PATH}/${i.id}/expertises`)),
        }),
        (error) => ({ error }),
      );
    },
    create({ args, data } = DEFAULT_PARAMS) {
      const [estimateId] = args;
      return rHandler(
        apiService.post(`${API_PATH}/${estimateId}/expertises`, data),
        (response) => ({
          response,
          item: new Expertise(response.data.data, `${API_PATH}/${estimateId}/expertises`),
        }),
        (error) => ({ error }),
      );
    },
    update({ args, data, obs } = DEFAULT_PARAMS) {
      const [estimateId, expertiseId] = args;
      return rHandler(
        apiService.put(`${API_PATH}/${estimateId}/expertises/${expertiseId}`, data),
        (response) => ({
          response,
          item: new Expertise(response.data.data, `${API_PATH}/${estimateId}/expertises/${expertiseId}`),
        }),
        (error) => ({ error }),
        obs,
      );
    },
  },
};
